import { FC } from "react";
import { Flex, Text } from "@smile2impress/components/relaunch";

import { Stars } from "components/Relaunch/Stars";

import { CustomerReviewProps } from "./CustomerReview.types";

export const CustomerReview: FC<CustomerReviewProps> = ({
    title,
    text,
    rating,
    customerName,
    date,
}) => {
    return (
        <Flex
            direction="column"
            p={[2, 2, 3]}
            bg="base.grey"
            borderRadius="sm"
            flexBasis="fit-content"
            h="100%"
            // alignSelf="stretch"
        >
            <Stars
                rating={rating}
                blockProps={{
                    mb: 1,
                }}
                iconProps={{
                    w: "16px",
                    h: "16px",
                }}
            />
            <Flex
                flexDirection="column"
                justifyContent="space-between"
                h="100%"
            >
                <Flex
                    direction={["column", "column", "column"]}
                    justifyContent="space-between"
                    pb={2}
                    flexBasis="fit-content"
                >
                    <Text
                        textStyle={"caption"}
                        fontWeight="bold"
                        color={["text.base"]}
                        mb={[1, 1, 1]}
                    >
                        {title}
                    </Text>
                    <Flex direction={"row"}>
                        <Text
                            textStyle={"body"}
                            color={["text.base", "text.base", "text.base"]}
                            mb={0}
                            dangerouslySetInnerHTML={{ __html: text ?? "" }}
                            minHeight="6em"
                            overflow="hidden"
                            textOverflow="ellipsis"
                            whiteSpace="pre-wrap"
                            overflowWrap="anywhere"
                        />
                    </Flex>
                </Flex>
                <Flex direction={"column"}>
                    <Text textStyle={"caption"} fontWeight="bold" mb={0.5}>
                        {customerName}
                    </Text>
                    <Text textStyle={"body"} opacity={0.5}>
                        {date}
                    </Text>
                </Flex>
            </Flex>
        </Flex>
    );
};
